import BannerTabs from './BannerTabs'

export default BannerTabs
